import { render, staticRenderFns } from "./ReturnToggleMaterials.vue?vue&type=template&id=623e68a6&scoped=true"
import script from "./ReturnToggleMaterials.vue?vue&type=script&lang=js"
export * from "./ReturnToggleMaterials.vue?vue&type=script&lang=js"
import style0 from "./ReturnToggleMaterials.vue?vue&type=style&index=0&id=623e68a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623e68a6",
  null
  
)

export default component.exports